/** 通知项目详情刷新 WBS 任务侧栏 */
export function notifyProjectWbsTasksChanged(projectId: number) {
  if (typeof window === 'undefined' || !projectId) return;
  window.dispatchEvent(
    new CustomEvent('aipd:wbs-tasks-changed', { detail: { projectId } }),
  );
}

export function subscribeProjectWbsTasksChanged(fn: (projectId: number) => void): () => void {
  const handler = (e: Event) => {
    const detail = (e as CustomEvent<{ projectId?: number }>).detail;
    const pid = Number(detail?.projectId || 0);
    if (pid > 0) fn(pid);
  };
  window.addEventListener('aipd:wbs-tasks-changed', handler);
  return () => window.removeEventListener('aipd:wbs-tasks-changed', handler);
}

/** 用户手动增删改 WBS 任务后派发（非 AI 生成同步） */
export function notifyProjectWbsTasksManuallyEdited(projectId: number) {
  if (typeof window === 'undefined' || !projectId) return;
  window.dispatchEvent(
    new CustomEvent('aipd:wbs-tasks-manually-edited', { detail: { projectId } }),
  );
}

export function subscribeProjectWbsTasksManuallyEdited(
  fn: (projectId: number) => void,
): () => void {
  const handler = (e: Event) => {
    const detail = (e as CustomEvent<{ projectId?: number }>).detail;
    const pid = Number(detail?.projectId || 0);
    if (pid > 0) fn(pid);
  };
  window.addEventListener('aipd:wbs-tasks-manually-edited', handler);
  return () => window.removeEventListener('aipd:wbs-tasks-manually-edited', handler);
}
